import { RX } from '../../constants/rx';
import { CREATE_MANHEIM_ACCOUNT } from '../../constants/resources';
import { getPrimaryEmailAndPhone } from '../../utils';

import CreateAccountForm from './CreateAccountForm/CreateAccountForm';
import { FEATURE } from '../../constants/features';

const { flex } = window;
const {
    React,
    ReactAddons: { PropTypes }
} = flex.lib;

const { loader, PrismMessage } = flex.components;

class CreateNewAccount extends React.Component {
    static propTypes = {
        registrationToken: PropTypes.string.isRequired,
        createNewAccount: PropTypes.shape({
            orgUser: PropTypes.object,
            username: PropTypes.isRequired,
            contactMethods: PropTypes.array,
            userHasActiveFlexAccount: PropTypes.bool,
            isFormEditable: PropTypes.bool,
            userCreationErrors: PropTypes.array
        })
    };

    static defaultProps = {
        createNewAccount: {}
    };

    componentDidMount() {
        flex.trigger(RX.CREATE_NEW_ACCOUNT.CLEAR_BRANCH);
        flex.trigger(RX.CREATE_NEW_ACCOUNT.GET_ORG_USER_BY_TOKEN, this.props.registrationToken);
    }

    renderErrorMessage = (message) => <PrismMessage color="warning">{message}</PrismMessage>;

    renderForm = (
        contactMethods,
        personInfo,
        username,
        userHasActiveFlexAccount,
        isFormEditable,
        userCreationErrors
    ) => {
        const { registrationToken } = this.props;
        const { firstName, lastName } = personInfo;
        let { email, phone } = getPrimaryEmailAndPhone(contactMethods);

        //Do not load for phone number for existed user US1003760
        if(flex.isFeatureToggleEnabled(FEATURE.ENABLE_AMS_USER_ORCHESTRATION)) {
            phone = userHasActiveFlexAccount ? '' : phone;
        }

        return (
            <CreateAccountForm
                registrationToken={registrationToken}
                firstName={firstName}
                lastName={lastName}
                email={email}
                phone={phone}
                userName={username}
                hasActiveFlexAccount={userHasActiveFlexAccount}
                isBusy={flex.isBusy(RX.CREATE_NEW_ACCOUNT.SUBMIT)}
                isFormEditable={isFormEditable}
                userCreationErrors={userCreationErrors}
            />
        );
    };

    renderFormContainer = () => {
        if (flex.isBusy(RX.CREATE_NEW_ACCOUNT.GET_ORG_USER_BY_TOKEN)) {
            return loader;
        }
        const {
            contactMethods,
            personInfo,
            username,
            userHasActiveFlexAccount,
            isFormEditable,
            userCreationErrors
        } = this.props.createNewAccount;

        return (
            <div className="create-new-account__form-container">
                {!personInfo
                    ? this.renderErrorMessage(CREATE_MANHEIM_ACCOUNT.USER_NOT_FOUND_MSG)
                    : this.renderForm(
                          contactMethods,
                          personInfo,
                          username,
                          userHasActiveFlexAccount,
                          isFormEditable,
                          userCreationErrors
                      )}
            </div>
        );
    };

    render() {
        return (
            <section className="container create-new-account">
                <h1 className="create-new-account__header">{CREATE_MANHEIM_ACCOUNT.HEADER}</h1>
                {this.renderFormContainer()}
            </section>
        );
    }
}

export default CreateNewAccount;
